<template>
  <div class="task">
    <headerPage></headerPage>
    <div class="task-page-content">
      <div class="task-font">我的课程</div>
      <div class="task-page-list">
        <div @click="toTaskInfo(item.taskId)" v-for="(item,index) in tableData" :key="index" class="task-page-item">
          <div class="task-page-image" v-if="item.image">
            <img style="width:100%;height:100%" :src="$store.state.HOST + item.image" @error="onImgError">
          </div>
          <div class="task-page-image-placeholder" v-else>
            <i class="el-icon-cpu placeholder-icon"></i>
            <div class="placeholder-name">{{item.taskName || '编程课程'}}</div>
          </div>
          <div class="task-page-name">
            <div class="task-page-name-one">{{item.taskName}}</div>
            <div class="task-page-name-two">{{item.taskDescribe}}</div>
          </div>
          <div class="task-page-user">
            <div>讲师：{{item.teacherName || '未知'}}</div>
            <div>
              学生：
              <i class="el-icon-star-off"></i>
              {{item.num || 0}}
            </div>
          </div>
        </div>
        <div v-if="tableData.length === 0 && !loading" class="task-empty">
          <i class="el-icon-folder-opened empty-icon"></i>
          <div class="empty-text">你还没有报名任何课程，快去探索吧！</div>
        </div>
      </div>
      <div class="task-page-fenye" v-if="total > 0">
        <el-pagination
          background
          :page-size="search.pageSize"
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <bottomPage></bottomPage>
  </div>
</template>

<script>
  import {getApeMyTaskPage} from '../../api/api' 
  import headerPage from "../../components/header/header"
  import bottomPage from "../../components/bottom/bottom"
  export default {
    data() {
      return{
        search: {
          pageSize: 12,
          pageNumber: 1
        },
        tableData: [],
        total: 0,
        loading: true
      }
    },
    components: {
      headerPage,
      bottomPage
    },
    methods: {
      query() {
        this.loading = true
        getApeMyTaskPage(this.search).then(res => {
          if (res.code == 1000) {
            this.tableData = res.data.records
            this.total = res.data.total
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      handleCurrentChange(val) {
        this.search.pageNumber = val
        this.query()
      },
      toTaskInfo(id) {
        this.$router.push("taskInfo?id="+id)
      },
      onImgError(e) {
        e.target.style.display = 'none'
      }
    },
    created() {
     
    },
    mounted() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      this.query()
    }
 }
</script>

<style scoped>
  @import url("../../assets/css/task/task.css");
  .task-empty {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
  }
  .task-empty .empty-icon {
    font-size: 72px;
    color: #C7CDFF;
    margin-bottom: 16px;
  }
  .task-empty .empty-text {
    font-size: 15px;
    color: var(--text-sub);
    letter-spacing: 1px;
  }
</style>
